export const isValidEmailAddress = (email: string) => {
  // Validate email patterns
  // eslint-disable-next-line prefer-regex-literals
  const emailPattern = new RegExp(
    /^[a-z0-9!#$%&'*+\-/=?^_`{|}~.]+@([a-z0-9%-]+\.){1,}([a-z0-9-]+)?$/i,
  );

  return emailPattern.test(email);
};
